<div class="media">
    <video autoplay class="media-object" loop muted playsinline>
        <source [src]="video" type="video/mp4">
    </video>
</div>
